import React from 'react'
import "./TopSection.css"
import { Container } from 'react-bootstrap'

const TopSection = ({ image, title, desc, subtitle }) => {
  return (
    <div className='tob-section-container'>
        <img src={image} className='tob-section-bg' />
        <Container>
            <div className='tob-section-content'>
                <div className='tob-section-title'>{title} <span>{subtitle}</span></div>
                <div className='tob-section-desc'>{desc}</div>
            </div>
        </Container>
    </div>
  )
}

export default TopSection